import { render, staticRenderFns } from "./OldPlansManagerDialog.vue?vue&type=template&id=423a1f5d&scoped=true"
import script from "./OldPlansManagerDialog.vue?vue&type=script&lang=js"
export * from "./OldPlansManagerDialog.vue?vue&type=script&lang=js"
import style0 from "./OldPlansManagerDialog.vue?vue&type=style&index=0&id=423a1f5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a1f5d",
  null
  
)

export default component.exports